module.exports = __webpack_public_path__ + "static/matza_1@1x-f9d4ecb978b6a0e22b841494e6b037fe.jpg";